import { defineComponent, ref, onMounted } from '@vue/composition-api';
import LabelAPI from 'src/api/labels';
import ProjectLabel from 'src/components/site/ProjectLabels/ProjectLabel.vue';
export default defineComponent({
    components: {
        ProjectLabel,
    },
    props: {
        filterLabels: { type: Array, default: () => [] }
    },
    setup() {
        const isFetching = ref(true);
        const labels = ref([]);
        const newLabel = ref(undefined);
        const fetchLabels = async (q) => {
            isFetching.value = true;
            const res = await LabelAPI.getLabels(undefined, q, q ? undefined : 50);
            labels.value = (res?.results ?? []);
            isFetching.value = false;
            return res;
        };
        onMounted(() => {
            fetchLabels('');
        });
        return {
            isFetching,
            newLabel,
            labels,
            fetchLabels,
        };
    },
    methods: {
        isActive(label) {
            return this.filterLabels.includes(label);
        },
        hasFilters() {
            return this.filterLabels.length > 0;
        }
    }
});
